import consumer from "./consumer";

export default class EnrollmentChannel {
  static create(enrollmentId, callbacks = {}) {
    return consumer.subscriptions.create({ channel: "EnrollmentNotificationsChannel", enrollment_id: enrollmentId }, {
      received(data) {
        this.callback('received')(data);
      },

      connected() {
        this.callback('connected')();
      },

      disconnected() {
        this.callback('disconnected')();
      },

      credit_card(status) {
        this.perform("credit_card", {
          enrollment_id: enrollmentId,
          status: status
        });
      },

      close() {
        // Unsubscribe only this subscription; the shared consumer's WebSocket
        // stays alive for the other channels multiplexed over it.
        this.unsubscribe();
      },

      callback(func_name) {
        return (callbacks[func_name] || (() => {})).bind(this);
      }
    });
  }
}